const STORAGE_KEY = "preview-upgrade-return";
const HANDLED_PAYMENT_KEY = "preview-upgrade-handled-payment";
const TTL_MS = 2 * 60 * 60 * 1000;

interface PendingPreviewUpgrade {
  transcriptionId: string;
  createdAt: number;
}

/**
 * Оплата уводит пользователя из SPA: ни один стор, кроме cookie-consent, не
 * переживает перезагрузку. Поэтому id превью, ради которого человек пошёл
 * платить, храним в localStorage и забираем на странице возврата.
 */
export const setPendingPreviewUpgrade = (transcriptionId: string): void => {
  try {
    const payload: PendingPreviewUpgrade = { transcriptionId, createdAt: Date.now() };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  } catch (error) {
    console.error("Ошибка сохранения намерения апгрейда превью:", error);
  }
};

export const clearPendingPreviewUpgrade = (): void => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    console.error("Ошибка очистки намерения апгрейда превью:", error);
  }
};

/** Читает маркер и сразу его гасит: возврат к записи нужен ровно один раз */
export const consumePendingPreviewUpgrade = (): string | null => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) {
      return null;
    }

    localStorage.removeItem(STORAGE_KEY);

    const parsed = JSON.parse(stored) as Partial<PendingPreviewUpgrade>;
    if (typeof parsed.transcriptionId !== "string" || typeof parsed.createdAt !== "number") {
      return null;
    }

    if (Date.now() - parsed.createdAt > TTL_MS) {
      return null;
    }

    return parsed.transcriptionId;
  } catch (error) {
    console.error("Ошибка чтения намерения апгрейда превью:", error);
    return null;
  }
};

/**
 * Платёж, по которому мы уже увели человека к его записи. Сокет
 * `payment:success` умеет жёстко редиректить на страницу успеха
 * (useBalanceWebSocket) — без этой отметки он утащил бы туда вкладку, из
 * которой человек ушёл платить. Отметку ставит вкладка с платёжкой, а читает
 * исходная, поэтому localStorage, а не sessionStorage: sessionStorage у вкладок
 * разный и защита бы не сработала.
 */
export const markPaymentHandled = (paymentId: string): void => {
  try {
    localStorage.setItem(HANDLED_PAYMENT_KEY, paymentId);
  } catch (error) {
    console.error("Ошибка отметки обработанного платежа:", error);
  }
};

export const isPaymentHandled = (paymentId: string): boolean => {
  try {
    return localStorage.getItem(HANDLED_PAYMENT_KEY) === paymentId;
  } catch (error) {
    console.error("Ошибка чтения обработанного платежа:", error);
    return false;
  }
};
